<template>
  <div>
    <nav class="navbar" :class="{ visible: isVisible }">
      <div class="nav-logo" @click="goToHome">*</div>
      <div class="nav-links">
        <router-link to="/" class="nav-link">Home</router-link>
        <router-link to="/shop" class="nav-link">Shop</router-link>
        <router-link to="/about" class="nav-link">Über uns</router-link>
        <router-link to="/contact" class="nav-link">Kontakt</router-link>
        <router-link to="/cart" class="nav-link cart-link">
          <svg class="cart-icon" viewBox="0 0 902.86 902.86" fill="currentColor">
            <g>
              <path d="M671.504,577.829l110.485-432.609H902.86v-68H729.174L703.128,179.2L0,178.697l74.753,399.129h596.751V577.829z M685.766,247.188l-67.077,262.64H131.199L81.928,246.756L685.766,247.188z"/>
              <path d="M578.418,825.641c59.961,0,108.743-48.783,108.743-108.744s-48.782-108.742-108.743-108.742H168.717c-59.961,0-108.744,48.781-108.744,108.742s48.782,108.744,108.744,108.744c59.962,0,108.743-48.783,108.743-108.744c0-14.4-2.821-28.152-7.927-40.742h208.069c-5.107,12.59-7.928,26.342-7.928,40.742C469.675,776.858,518.457,825.641,578.418,825.641z M209.46,716.897c0,22.467-18.277,40.744-40.743,40.744c-22.466,0-40.744-18.277-40.744-40.744c0-22.465,18.277-40.742,40.744-40.742C191.183,676.155,209.46,694.432,209.46,716.897z M619.162,716.897c0,22.467-18.277,40.744-40.743,40.744s-40.743-18.277-40.743-40.744c0-22.465,18.277-40.742,40.743-40.742S619.162,694.432,619.162,716.897z"/>
            </g>
          </svg>
          <span v-if="cartStore.getItemCount() > 0" class="cart-count">{{ cartStore.getItemCount() }}</span>
        </router-link>
      </div>
      <button 
        class="nav-menu-button" 
        :class="{ active: mobileMenuActive }"
        @click="toggleMobileMenu"
        aria-label="Toggle Menu"
      >
        <span></span>
      </button>
    </nav>

    <!-- Mobile menu outside the nav element for better stacking -->
    <div class="mobile-menu" :class="{ active: mobileMenuActive }">
      <div class="mobile-menu-content">
        <router-link 
          to="/" 
          class="mobile-link" 
          style="--index: 0"
          @click="closeMobileMenu"
        >
          Home
        </router-link>
        <router-link 
          to="/shop" 
          class="mobile-link" 
          style="--index: 1"
          @click="closeMobileMenu"
        >
          Shop
        </router-link>
        <router-link 
          to="/about" 
          class="mobile-link" 
          style="--index: 2"
          @click="closeMobileMenu"
        >
          Über uns
        </router-link>
        <router-link 
          to="/contact" 
          class="mobile-link" 
          style="--index: 3"
          @click="closeMobileMenu"
        >
          Kontakt
        </router-link>
        <router-link 
          to="/cart" 
          class="mobile-link cart-link" 
          style="--index: 4"
          @click="closeMobileMenu"
        >
          <svg class="cart-icon" viewBox="0 0 902.86 902.86" fill="currentColor">
            <g>
              <path d="M671.504,577.829l110.485-432.609H902.86v-68H729.174L703.128,179.2L0,178.697l74.753,399.129h596.751V577.829z M685.766,247.188l-67.077,262.64H131.199L81.928,246.756L685.766,247.188z"/>
              <path d="M578.418,825.641c59.961,0,108.743-48.783,108.743-108.744s-48.782-108.742-108.743-108.742H168.717c-59.961,0-108.744,48.781-108.744,108.742s48.782,108.744,108.744,108.744c59.962,0,108.743-48.783,108.743-108.744c0-14.4-2.821-28.152-7.927-40.742h208.069c-5.107,12.59-7.928,26.342-7.928,40.742C469.675,776.858,518.457,825.641,578.418,825.641z M209.46,716.897c0,22.467-18.277,40.744-40.743,40.744c-22.466,0-40.744-18.277-40.744-40.744c0-22.465,18.277-40.742,40.744-40.742C191.183,676.155,209.46,694.432,209.46,716.897z M619.162,716.897c0,22.467-18.277,40.744-40.743,40.744s-40.743-18.277-40.743-40.744c0-22.465,18.277-40.742,40.743-40.742S619.162,694.432,619.162,716.897z"/>
            </g>
          </svg>
          <span v-if="cartStore.getItemCount() > 0" class="cart-count">{{ cartStore.getItemCount() }}</span>
          Cart
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { cartStore } from '@/store/cart.js'

export default {
  name: 'Navbar',
  data() {
    return {
      isVisible: false,
      mobileMenuActive: false
    }
  },
  computed: {
    cartStore() {
      return cartStore
    }
  },
  mounted() {
    setTimeout(() => {
      this.isVisible = true;
    }, 300);
  },
  methods: {
    goToHome() {
      this.$router.push('/');
      this.closeMobileMenu();
    },
    toggleMobileMenu() {
      this.mobileMenuActive = !this.mobileMenuActive;
      
      // Prevent scrolling of the body when menu is open
      if (this.mobileMenuActive) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    },
    closeMobileMenu() {
      this.mobileMenuActive = false;
      document.body.style.overflow = '';
    }
  }
}
</script>

<style scoped>
/* Cart button styles */
.cart-link {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  position: relative;
}

.cart-icon {
  width: 20px;
  height: 20px;
  fill: currentColor;
}

.cart-count {
  background: black;
  color: white;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  font-weight: 600;
  position: absolute;
  top: -8px;
  right: -8px;
}

/* Mobile menu button styles */
.nav-menu-button {
  background: transparent;
  border: none;
  outline: none;
  padding: 10px;
  margin: 0;
}

/* Mobile menu specific styles */
.mobile-menu-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
}

.mobile-link.cart-link {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  position: relative;
}
</style>